import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Fit20StartHome",
    component: () => import("../views/Fit20StartHome.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
